class Configuration {
  SERVICE_NAME_SETTING = "/setting";
  SERVICE_NAME_USER = "/user";
  SERVICE_NAME_USER_DESTROY = "/user/destroy";
  SERVICE_NAME_APPLICANT = "/applicant";
  SERVICE_NAME_APPLICANT_DESTROY = "/applicant/destroy";
  SERVICE_NAME_APPLICANT_SETTINGFILTER = "/setting_filter";
  SERVICE_NAME_APPLICANT_SEARCH = "/applicant/search";
  SERVICE_NAME_APPLICANT_MULTIDELETE = "/applicant/multiDelete";
  SERVICE_NAME_APPLICANT_DOWNLOAD = "/download";
  SERVICE_NAME_APPLICANT_EXPORT_SINGLE = "/applicant/export/single";
  SERVICE_NAME_APPLICANT_EXPORT_MULTIPLE = "/applicant/export/multiple";
  SERVICE_NAME_APPLICANT_CHECK = "/applicant/check";
  SERVICE_NAME_SET_INTERVIEW = "/setInterview";
  SERVICE_NAME_JOB_TYPE = "/jobType";
  SERVICE_NAME_JOB_TYPE_DESTROY = "/jobType/destroy";
  SERVICE_NAME_JOB_CATEGORY = "/jobCategory";
  SERVICE_NAME_UPLOAD = "/upload";
  SERVICE_NAME_LOGIN = "/login";
  SERVICE_NAME_LOGOUT = "/logout";
  SERVICE_NAME_CHANGE_PASSWORD = "/changePassword";
  SERVICE_NAME_FILES = "/files";
  SERVICE_NAME_DOWNLOADFILES = "/downloadFiles";
  SERVICE_NAME_DELETEFILES = "/deleteFiles";
  SERVICE_NAME_RELIGION = "/religions";
  SERVICE_NAME_EDU_GRADE = "/eduGrade";
  SERVICE_NAME_PERMISSION = "/permission";
  SERVICE_NAME_USER_PERMISSION = "/userPermission";
}
export default Configuration;
